import PropTypes from "prop-types";
import React from "react";
import Spinner from "react-spinner-material";
import XMLViewer from "react-xml-viewer";

const customTheme = {
  attributeKeyColor: "#B7B7B7",
  attributeValueColor: "#B7B7B7",
  textColor: "#8D8D8D",
  tagColor: "#FF585F",
  overflowBreak: true,
  separatorColor: "#3B86FF",
};

const XMLViewerDiv = (props) => {
  const { request, response, isLoading, runSuccess } = props;

  return (
    <div className="test-xml-display">
      {isLoading ? (
        <div className="center-spinner">
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : (
        runSuccess && (
          <div className="test-xml-display-section">
            <div className="test-xml-display-section-request">
              <div className="top">
                <div className="test-xml-display-section-btn">REQUEST</div>
              </div>
              <div className="box">
                {!request || request === "" ? (
                  <span>No Request Available</span>
                ) : (
                  <XMLViewer xml={request} theme={customTheme} indentSize={3} />
                )}
              </div>
            </div>
            <div className="test-xml-display-section-response">
              <div className="top">
                <div className="test-xml-display-section-btn response">
                  RESPONSE
                </div>
                <div className="test-xml-display-section-success">
                  <div className="green-bullet"></div>
                  <span>Successful</span>
                </div>
              </div>
              <div div className="box">
                {!response || response === "" ? (
                  <span>No Response Available</span>
                ) : (
                  <XMLViewer
                    xml={response}
                    theme={customTheme}
                    indentSize={3}
                  />
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

XMLViewerDiv.propTypes = {
  isLoading: PropTypes.any,
  request: PropTypes.any,
  response: PropTypes.any,
  runSuccess: PropTypes.any,
};

export default XMLViewerDiv;
